export const sources = {
	webp: "__VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__ 400w, __VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 800w"
};
export const img = {
	src: "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
